import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
//import 'rxjs/add/operator/do';
import { tap } from 'rxjs/operators';

import { AuthenticationService } from './authentication.service';
import { AdminLocalStorageService } from './admin-local-storage.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(public auth: AuthenticationService
    , private localStorage: AdminLocalStorageService
    , private router: Router
    , private toastr: ToastrService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = this.localStorage.getToken();
        let requestItem = request;
        if (token && environment.production) {
            requestItem = request.clone({
                headers: request.headers.set("Authorization",
                token).set("x-api-key","p6sTQ24gE64yVmtwJiUjv7ZwTN5giAXpa6jzIvaV")
            });
        }
        return next.handle(requestItem).pipe(tap((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
              //letting it pass
            }
        }, (err: any) => {
            if (err instanceof HttpErrorResponse) {
                if (err.status === 401 || err.status === 0) {
                    //this.localStorage.deleteToken();
                    this.toastr.error("Please login again.", "Session ended");
                    let url = environment.awslogin;
                    //this.router.navigateByUrl("/auth")
                    //window.location.assign(url);
                    //this.router.navigate(['/']);
                }
            }
        }));
    }
}
